var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"business-banner row items-center justify-between bg-grey-3"},[_c('img',{staticClass:"business-banner-logo",style:(_vm.logo.travelAgentBannerStyle
        ? _vm.logo.travelAgentBannerStyle
        : { maxWidth: 'calc(50% - 16px)' }),attrs:{"src":_vm.logo.src},on:{"load":function($event){return _vm.$emit('loadAllContent', true)}}}),_c('div',{staticClass:"col-6 row items-stretch justify-end q-ml-auto"},[_c('div',{class:[
        'column items-end justify-center text-uppercase names',
        {
          'cursor-pointer': _vm.businessBanner.clickable,
          'cursor-default': !_vm.businessBanner.clickable,
        },
      ],on:{"click":_vm.openBusinessCard}},[_c('div',{staticClass:"name text-weight-semibold text-right"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"title text-right text-weight-semibold color-grey-5"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])]),_c('div',{class:[
        'row items-center justify-center',
        {
          'cursor-pointer': _vm.businessBanner.clickable,
          'cursor-default': !_vm.businessBanner.clickable,
        },
      ],on:{"click":_vm.openBusinessCard}},[(_vm.avatar.src)?_c('q-avatar',{staticClass:"avatar-image",attrs:{"size":"40px"}},[_c('img',{attrs:{"src":_vm.avatar.src}})]):_c('div',{staticClass:"row items-center justify-center avatar-name bg-white"},[_vm._v("\n        "+_vm._s(_vm.avatar.name)+"\n      ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }